/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankAccountType {
  CONTA_CORRENTE = 'CONTA_CORRENTE',
  CONTA_POUPANCA = 'CONTA_POUPANCA',
}
